<div class="flex gap-8">
  @for (col of matrix(); track $index) {
    <rid-word-list
      [words]="col"
      [delay]="100 * $index"
      (selectionChanged)="selectionChanged.emit({ kind: $event.kind, index: [$index, $event.index] })"
    />
  }
</div>
